import React, { Component } from "react";
import PropTypes from "prop-types";

class BrandsListKeyComponent extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    const { brandKey } = this.props;
    this.props.brandBlock(brandKey);
  }

  render() {
    const { brandKey } = this.props;
    return brandKey && brandKey.length ? (
      <div
        rel="button"
        onClick={this.handleClick}
        role="presentation"
        className="nw-brandslist-keys"
      >
        {brandKey}
      </div>
    ) : null;
  }
}

BrandsListKeyComponent.propTypes = {
  brandKey: PropTypes.string.isRequired,
  brandBlock: PropTypes.func.isRequired,
};

const getFinalComponent = component => component;

const ProjectComponent = {
  getFinalComponent,
  wrapper: BrandsListKeyComponent,
  component: BrandsListKeyComponent,
};

export default ProjectComponent;



// WEBPACK FOOTER //
// ./src/pages/BrandsList/BrandsListKeyComponent/index.js